import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=a25ec6e0&scoped=true&"
import script from "./Requests.vue?vue&type=script&lang=ts&"
export * from "./Requests.vue?vue&type=script&lang=ts&"
import style0 from "./Requests.vue?vue&type=style&index=0&id=a25ec6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25ec6e0",
  null
  
)

export default component.exports